export enum NotificationTypeId {
  BrandAssetsUpdateFailed = 'Updating brand assets failed',
  BrandAssetsUpdateInvalidJSON = 'Updating brand assets invalid json',
  ClassImportFailed = 'Class import failed',
  ClassImportRunning = 'Class import running',
  ClassImportSucceeded = 'Class import finished',
  CopyAnnotationsDone = 'Annotations copied',
  CopyAnnotationsFailed = 'Failed to copy annotations',
  CopyAnnotationsPartiallyDone = 'Annotations copied partially',
  CopyAnnotationsProgress = 'Copying annotations',
  CustomJobFailed = 'Job failed',
  CustomJobFinished = 'Job finished',
  DataImportFailed = 'Data import failed',
  DataImportRolledBack = 'Data import rolled back',
  DataImportRunning = 'Data import running',
  DataImportStopped = 'Data import stopped',
  DataImportSucceeded = 'Data import succeeded',

  ExportFailed = 'Export failed',
  ExportFailedMissingData = 'Export failed (missing data)',
  ExportFinished = 'Export finished',
  ExportStarted = 'Export started',
  ExportStopped = 'Export stopped',
  ImportFailed = 'Import failed',
  ImportFailedEmptyManifestSelection = 'Import failed (empty manifest selection)',
  ImportFailedIncompatibleAlgorithm = 'Import failed (incompatible algorithm)',
  ImportFailedInsufficientStorage = 'Import failed (insufficient storage)',
  ImportFinished = 'Import finished',
  ImportStarted = 'Import started',
  ImportStopped = 'Import stopped',
  InferenceFailed = 'Inference failed',
  InferenceInsufficientResources = 'Insufficient inference resources',
  InferenceResourceLimitReached = 'Inference resource limit reached',
  InferenceStopped = 'Inference stopped',
  PlatformDeploymentPushed = 'Pushing inference setup finished',
  PlatformDeploymentPushFailed = 'Pushing inference setup failed',
  PlatformDeploymentPushStarted = 'Pushing inference setup',
  PlatformDeploymentPushStopped = 'Pushing inference stopped',
  RecordingFailed = 'Recording failed',
  RecordingFinished = 'Recording finished',
  SampleImportFailed = 'Sample import failed',
  SilencedImportSampleFailures = 'Sample imports failed silently',
  StorageAlarm = 'Storage is full',
  StorageWarning = 'Storage is almost full',
  TestFailed = 'Test failed',
  TestFinished = 'Test finished',
  TrainingFailed = 'Training failed',
  TrainingFinished = 'Training finished',
  TrainingResourceLimitReached = 'Training resource limit reached',
  UnresponsiveJob = 'Unresponsive job',
  UpdateAnnotationsDone = 'Samples annotated successfully',
  UpdateAnnotationsFailed = 'Failed to annotate samples',
  UpdateAnnotationsPartiallyDone = 'Samples annotated partially',
  UpdateAnnotationsProgress = 'Annotating samples',
}
